import { RouteObject } from 'react-router-dom';

import NotFoundPage from 'src/components/layout/NotFound';
import PrivateLayout from 'src/components/layout/PrivateLayout';
import SelectAvailability from 'src/pages/SelectAvailability';

const routeData: RouteObject[] = [
  {
    path: '/:tenantAccessCode/:tenantContactHash?',
    element: <PrivateLayout />,
    children: [
      {
        index: true,
        element: <SelectAvailability />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routeData;
